import { render, staticRenderFns } from "./ReferralsSettingsTab.vue?vue&type=template&id=5f7bad86&scoped=true&"
import script from "./ReferralsSettingsTab.vue?vue&type=script&lang=js&"
export * from "./ReferralsSettingsTab.vue?vue&type=script&lang=js&"
import style0 from "./ReferralsSettingsTab.vue?vue&type=style&index=0&id=5f7bad86&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f7bad86",
  null
  
)

export default component.exports